import { render, staticRenderFns } from "./thaw-file.vue?vue&type=template&id=3fa4a886"
import script from "./thaw-file.vue?vue&type=script&lang=js"
export * from "./thaw-file.vue?vue&type=script&lang=js"
import style0 from "./thaw-file.vue?vue&type=style&index=0&id=3fa4a886&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports